import { mapGetters, mapMutations } from 'vuex';
import { isNullOrUndefined } from 'util';
import { orderService } from '../../services/OrderService'

import Offer from './editOfferComponent.vue';

export default {
    name: 'Offers',

    components: {
        Offer
    },

    props:
    {
        orderCachekey: {
            type: String
        },
        showExtraOffers: {
            type: Boolean
        },
        showFriendlyErrors : {
            type: Boolean
        },
        showConfirmationMessage: {
            type: Boolean
        },
        showErrorsAtEnd: {
            type: Boolean
        }

    },

    data: () => {
        return {
            loading: true,

            currentPage: 1,
            perPage: 100,
            loadinOffers: false,
            fields: [],
            offers: [],
            saving: false,
            receivedResponses: 0,
            expectedResponses: 0,
            sortByCol: '',
            keyId: 0,
        }
    },

    created() {
        this.fields = [
            { key: 'Insurer', label: 'Societate', sortable: true, thStyle: 'width:20%' },
        ];

        // sort by ValidityPeriod
        this.orderVehicleOptions.ValidityPeriod.sort(function (a, b) { return a - b; });

        if (this.orderVehicleOptions.ValidityPeriod.length > 0) {
            this.fields.push({ key: 'OfferP1.Price', label: this.orderVehicleOptions.ValidityPeriod[0] + ' luni', sortable: true, thStyle: 'width:40%;text-align:center' });
        }

        if (this.orderVehicleOptions.ValidityPeriod.length > 1) {
            this.fields.push({ key: 'OfferP2.Price', label: this.orderVehicleOptions.ValidityPeriod[1] + ' luni', sortable: true, thStyle: 'width:40%;text-align:center' });
        }

        // number of expected receivedResponses
        this.expectedResponses = this.receivedResponses = 0;//this.orderVehicleOptions.ValidityPeriod.length * this.order.SelectedInsurers.length;
        this.createEmptyOffersList();
    },

    computed: {
        ...mapGetters(
            {
                selectedOffer: 'order/selectedOffer',
                orderOffers: 'order/offers',
                order: 'order/order',
                orderVehicleOptions: 'order/vehicleOptions',
            }),

        selecteOfferTotal() {
            if (this.selectedOffer == null)
                return 0;
            var total = this.selectedOffer.Price;
            if (this.selectedOffer.ExtraOffers != null) {
                this.selectedOffer.ExtraOffers.forEach(extraOffer => {
                    if (extraOffer.Selected) {
                        total += extraOffer.Value;
                    }
                });
            }

            return total;
        },
        canSaveOffer() {
            return this.receivedResponses == 0;
        }
    },

    methods: {
        ...mapMutations({
            setSelectedOffer: 'order/setSelectedOffer',
        }),
        createEmptyOffersList() {
            this.order.SelectedInsurers.forEach(insurer => {
                this.offers.push(
                    {
                        Insurer: insurer,
                        OfferP1: {
                            Price: 0,
                            HasErrors:false,
                        },
                        
                        OfferP2: {
                            Price: 0,
                            HasErrors: false,
                        },
                        OrderCachekey: this.orderCachekey,
                    })
            });
        },

        confirmOrder: function () {
            console.log('confirmOrder');
            var model = this;
            this.saving = true;
            orderService.confirmOrder(this.selectedOffer).then(function () {
                //model.$refs['confirmModal'].hide();
                model.saving = false;
                model.$emit('orderSaved');
            });
        },

        extraOffersChanged: function (offer) {
            this.getOfferTotal(offer);
        },

        offerP1Received(value) {
            this.offers.find(item => item.Insurer == value.Insurer).OfferP1 = value;
            this.receivedResponses++;
            //this.keyId++;
        },

        offerP2Received(value) {
            this.offers.find(item => item.Insurer == value.Insurer).OfferP2 = value;
            this.receivedResponses++;
            //this.keyId++;
        },
        offerRequested(company) {

            this.expectedResponses++;
        },
        offerSelected: function (offer) {

            this.setSelectedOffer(offer);
            if (this.showConfirmationMessage) {
                this.$refs['confirmModal'].show()
            }
            else {
                var model = this;
                this.saving = true;
                orderService.confirmOrder(this.selectedOffer).then(function (response) {
                    //model.$refs['confirmModal'].hide();
                    model.saving = false;
                    model.$emit('orderSaved', response.data);
                });
            }
            
        },

        getLogo: function (insurer) {
            return 'img/logos/' + insurer + '-logo.png';
        },


        hideConfirmModal: function () {
            this.$refs['confirmModal'].hide()
        },

       
       
    },
    watch: {
        receivedResponses: {
            handler: function (val) {
                // reload order if route was changed
                if (val == this.expectedResponses && this.expectedResponses > 0) {
                    // ply sort when all offers are ceceived
                    this.sortByCol = 'OfferP1.Price';
                    // enit event
                    this.$emit('allOffersReceived');
                }
            }
        },
    }
}
